import React from 'react'
import { StyledLogo } from './styles'

const srcLogo = require('App/assets/images/ic_moca_logo.png')

const MocaLogo = props => (
  <StyledLogo
    src={srcLogo}
    alt={'logo-moca'}
    {...props}
  />
)

export default MocaLogo
